import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export enum PourActionType {
    KeepAlive = 0,
    Start = 1,
    Stop = 2,
    BeginCalibration = 3,
    InterruptCalibration = 4,
    CalibrationApproval = 5,
}

export interface CalibrationResultData {
    error: number
    lasted: number
    pwm: number
    stopValidationTime: number
}

export interface IPourUpdate {
    type: PourActionType
    flavor?: number
    soda?: boolean
    pump?: number
    key?: number
    lasted?: number
    mlPerSec?: number
}
export async function clientPourAction(clientId: IClientUID, update: IPourUpdate): Promise<ApiResponse<void | CalibrationResultData>> {
    const response = await fetch(`${HOST_URL}pour-action`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, ...update }),
    })
    const result = (await response.json()) as any
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
